export const messages = {
  en: {
    communitySpaceManage: {
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      venue: 'Venue',
      spaceId: 'ID',
      name: 'Name',
      startTime: 'Opening Time',
      endTime: 'Closing Time',
      feeMoney: 'Hourly Fee',
      adminName: 'Manager',
      tel: 'Manager Phone',
      state: 'Status',
      operation: 'Operation',
      openTime: 'Open Time',
      query: 'Search',
      reset: 'Reset',
      addSpace: 'Add Space',
      document: 'Document',
      venueName: 'Venue Name',
      description: 'Description',
      confirmDelete: 'Confirm Delete',
      cancel: 'Cancel',
      save: 'Save',
      selectStatus: 'Select Status',
      selectVenue: 'Select Venue',
      selectSpace: 'Select Space',
      status1001: 'Available',
      status2002: 'Unavailable',
      confirmDeleteSpace: 'Confirm to delete space?',
      confirmDeleteVenue: 'Confirm to delete venue?',
      openTimeTitle: 'Opening Hours',
      venueInfo: 'Venue Information',
      spaceInfo: 'Space Information'
    }
  },
  zh: {
    communitySpaceManage: {
      add: '添加',
      edit: '修改',
      delete: '删除',
      venue: '场馆',
      spaceId: '编号',
      name: '名称',
      startTime: '开场时间',
      endTime: '关场时间',
      feeMoney: '每小时费用',
      adminName: '管理员',
      tel: '管理员电话',
      state: '状态',
      operation: '操作',
      openTime: '开放时间',
      query: '查询',
      reset: '重置',
      addSpace: '添加场地',
      document: '文档',
      venueName: '场馆名称',
      description: '描述',
      confirmDelete: '确认删除',
      cancel: '取消',
      save: '保存',
      selectStatus: '请选择状态',
      selectVenue: '请选择场馆',
      selectSpace: '请选择场地',
      status1001: '可预约',
      status2002: '不可预约',
      confirmDeleteSpace: '确定删除场地?',
      confirmDeleteVenue: '确定删除场馆?',
      openTimeTitle: '开放时间',
      venueInfo: '场馆信息',
      spaceInfo: '场地信息'
    }
  }
}